import { computed, type Ref } from "vue";

import gcalIcon from "@/assets/apps/gcal.svg";
import contactsIcon from "@/assets/contacts.svg";
import * as inject from "@/components/inject";
import { RouteNames } from "@/routes/types";
import type { Router } from "@/types";
import { navigateTo } from "@/utils/navigate";

import type { IntegrationItem } from "./types";

export function useIntegrationsGoogle(orgId: Ref<string>, router: Router) {
  const hasCalendar = inject.hasCalendar();
  const hasContacts = inject.hasContacts();

  const configureGoogleCalendar = () => {
    navigateTo(RouteNames.SettingsIntegrationsGoogleCalendar, router, {
      params: { orgId: orgId.value },
    });
  };

  const configureGoogleContacts = () => {
    navigateTo(RouteNames.SettingsIntegrationsGoogleContacts, router, {
      params: { orgId: orgId.value },
    });
  };

  const connectedItems = computed<IntegrationItem[]>(() => {
    const items: IntegrationItem[] = [];
    if (hasCalendar.value) {
      items.push({
        id: "google-calendar",
        name: "Google Calendar",
        description: "Sync events to Agenda and Calendar.",
        type: "google-calendar",
        logoUri: gcalIcon,
        onClick: configureGoogleCalendar,
      });
    }
    if (hasContacts.value) {
      items.push({
        id: "google-contacts",
        name: "Google Contacts",
        description: "Search and use your contacts in Routine.",
        type: "google-contacts",
        logoUri: contactsIcon,
        onClick: configureGoogleContacts,
      });
    }
    return items;
  });

  const availableItems = computed<IntegrationItem[]>(() => {
    const items: IntegrationItem[] = [];
    if (!hasCalendar.value) {
      items.push({
        id: "google-calendar",
        name: "Google Calendar",
        description: "Sync events to Agenda and Calendar.",
        type: "google-calendar",
        logoUri: gcalIcon,
        onClick: configureGoogleCalendar,
      });
    }
    if (!hasContacts.value) {
      items.push({
        id: "google-contacts",
        name: "Google Contacts",
        description: "Search and use your contacts in Routine.",
        type: "google-contacts",
        logoUri: contactsIcon,
        onClick: configureGoogleContacts,
      });
    }
    return items;
  });

  return { connectedItems, availableItems };
}
